import {AppState} from "../RootReducer";
import {createSelector} from "reselect";
import { Contribution, ContributionProduct } from "../http/protocol";

export const journeyHasReceivePromo = (app : AppState) => {
    if(app.journey.journey?.userAttributes) {
        return !!Object.keys(app.journey.journey?.userAttributes).find(k => k === "receivePromoCommunication");
    }
    return false;
}
export const getLoggedIn = (state : AppState) => state.user?.user?.loggedIn ?? false;
export const getUserUid = (state : AppState) => state.user?.user?.userUid ?? false;

export const PREFERRED_POKER_EXCHANGE_CURRENCY = "preferredPokerExchangeCurrency";
export const getPreferredPokerExchangeCurrency = (state : AppState) => state.user?.user?.attributes?.[PREFERRED_POKER_EXCHANGE_CURRENCY];

export const isUserInfoLoaded = (state : AppState) => state.user.user?.loggedIn === true || state.user.user?.loggedIn === false;

export const getCountry = (state: AppState) => state.user?.user?.country;

export const getActiveCurrencyCode = (state : AppState) => {
    return state.user.activeCurrency ?? state.user.user?.currencies?.[0]?.code;
}

export const getUserCountry = (state : AppState) => state.user.user?.country;
export const getUserAttributes = (state : AppState) => state.user.user?.attributes ?? {};
export const gerUserCurrency = (state : AppState) => state.user.activeCurrency;

export const getUserCurrencies = (state : AppState) => state.user?.user?.currencies ?? [];


export const getActiveCurrency = createSelector([gerUserCurrency, getUserCurrencies], (currencyCode, currencies) => {
    if(currencyCode && currencies.length > 0) {
        return currencies.find(c => c.code == currencyCode) ?? currencies[0];
    } else if(currencies.length >0) {
        return currencies[0];
    }
    return undefined;
})

const getCurrencyCode = (_:any, currencyCode : string) => currencyCode;
export const getCurrencyByCode = createSelector([getUserCurrencies,getCurrencyCode], (currencies, code) => {
    return currencies.find(c => c.code == code);
})


export const getVisibleCurrencies = createSelector([getUserCurrencies], (currencies) => {
    return currencies.filter(c => c.visible)
})

export const getBalances = (state : AppState) => state.user.balances ?? [];

export const getHasActiveCasinoBonus = (state : AppState): boolean | undefined => {
    const activeBonus = state.user.activeBonuses?.[0];
    if(activeBonus == null) return false;

    const { contributions = [] } = activeBonus?.bonusConfig?.turnoverContributions ?? {};

    return contributions?.some((c: Contribution) => c.product === ContributionProduct.CASINO);
};

export const getAppMode = (state : AppState) => state.user.appMode;




export const getUserLevelView = (state : AppState) => state.user.userLevelView;

